var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.item, _vm.$style[_vm.split] ,
  _vm.$style[("size-" + _vm.handleSize + "-" + _vm.split)],
  _vm.xClass]})}
var staticRenderFns = []

export { render, staticRenderFns }